import { useState } from "react";
import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

const groups: { title: string; items: { q: string; a: string }[] }[] = [
  {
    title: "Orders",
    items: [
      { q: "Can I amend or cancel an order?", a: "We can amend or cancel any in-stock order within 12 hours of purchase. Made-to-order pieces cannot be cancelled once production has begun." },
      { q: "How will I receive updates?", a: "You will receive an email when your order is confirmed, when it enters production, and when it is dispatched with tracking." },
    ],
  },
  {
    title: "Materials",
    items: [
      { q: "What metals do you use?", a: "All Aurelin pieces are cast in solid 18k recycled gold, sterling silver or platinum. We never use plating." },
      { q: "Are your stones ethically sourced?", a: "Yes. Every stone is traceable and sourced through partners certified against Kimberley Process and Responsible Jewellery Council standards." },
    ],
  },
  {
    title: "Sizing",
    items: [
      { q: "How do I find my ring size?", a: "Order a complimentary Aurelin sizing kit from our client care team, or visit any of our stockists for an in-person fitting." },
      { q: "Can I resize a piece later?", a: "Most rings can be resized once within the first year of purchase, complimentary." },
    ],
  },
  {
    title: "Shipping",
    items: [
      { q: "Do you ship internationally?", a: "Yes. Complimentary insured, signature-required shipping is offered worldwide." },
      { q: "How long does delivery take?", a: "Made-to-order pieces typically dispatch within 5–7 business days from our Antwerp atelier." },
    ],
  },
  {
    title: "Returns",
    items: [
      { q: "What is your return policy?", a: "Unworn pieces may be returned within 30 days of delivery for a full refund, in their original Aurelin packaging." },
      { q: "Are any pieces final sale?", a: "Engraved, resized or bespoke pieces are considered final sale." },
    ],
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<string | null>(null);
  const toggle = (k: string) => setOpen(open === k ? null : k);

  return (
    <Layout>
      <section>
        <div className="shell pt-24 pb-16">
          <Breadcrumb items={[{ label: "FAQ" }]} />
          <h1 className="mt-8 font-display text-5xl md:text-6xl text-black">Frequently Asked</h1>
        </div>
        <div className="shell pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8 md:col-start-3 space-y-12">
            {groups.map((g) => (
              <div key={g.title}>
                <h2 className="eyebrow mb-4">{g.title}</h2>
                <div className="border-t border-black/10">
                  {g.items.map((it, i) => {
                    const key = `${g.title}-${i}`;
                    const isOpen = open === key;
                    return (
                      <div key={key} className="border-b border-black/10">
                        <button
                          onClick={() => toggle(key)}
                          className="w-full flex items-center justify-between py-5 text-left cursor-pointer"
                        >
                          <span className="text-[15px] text-black">{it.q}</span>
                          <span className="w-4 h-4 flex items-center justify-center text-graphite">
                            <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                          </span>
                        </button>
                        {isOpen && <p className="pb-6 pr-8 text-graphite leading-[1.9] text-[14px]">{it.a}</p>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}